"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCollectionWithMultipleIndexes = void 0;
const Logger_1 = require("./Logger");
const createCollectionWithMultipleIndexes = (db, collectionName, indexes) => __awaiter(void 0, void 0, void 0, function* () {
    const collectionExists = (yield db.listCollections().toArray()).some(({ name }) => name === collectionName);
    if (!collectionExists) {
        Logger_1.logger.info({ message: `Creating collection '${collectionName}` });
        yield db.createCollection(collectionName);
        const collection = db.collection(collectionName);
        for (const { key, indexOptions } of indexes) {
            yield collection.createIndex(key, indexOptions);
        }
        Logger_1.logger.info({ message: `Collection '${collectionName}' is ready.` });
    }
});
exports.createCollectionWithMultipleIndexes = createCollectionWithMultipleIndexes;
